import { supabase } from './supabase';

export interface SetBundelkortingResult {
  geenBundelkorting: boolean;
  nieuweTotaalInclBtw: number | null;
}

/**
 * Zet de automatische bundelkorting aan/uit voor een offerte (Lead-Id) of order
 * (Werk_Order__c-Id). `geenBundelkorting=true` sluit de parent uit van de
 * automatische volumekorting; bewuste KORTING:-/campagnekortingen blijven gelden.
 * Salesforce herprijst direct (PricingService).
 */
export async function setBundelkorting(
  recordId: string,
  geenBundelkorting: boolean,
): Promise<SetBundelkortingResult> {
  const { data: { session } } = await supabase.auth.getSession();
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (session?.access_token) headers['Authorization'] = `Bearer ${session.access_token}`;

  const response = await fetch('/api/bundelkorting', {
    method: 'POST',
    headers,
    body: JSON.stringify({ recordId, geenBundelkorting }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Bundelkorting wijzigen mislukt' }));
    throw new Error(err.error || err.message || 'Bundelkorting wijzigen mislukt');
  }
  const payload = (await response.json()) as {
    geenBundelkorting?: boolean;
    nieuweTotaalInclBtw?: number | null;
  };
  return {
    geenBundelkorting: payload.geenBundelkorting ?? geenBundelkorting,
    nieuweTotaalInclBtw: payload.nieuweTotaalInclBtw ?? null,
  };
}
